import Icon from "@/components/Icon";
import type { MaterialNames } from "@/components/material_symbol_names";

type DashboardTabIconProps = {
  materialIcon: MaterialNames;
  size?: number;
};

export default function DashboardTabIcon({ materialIcon, size = 20 }: DashboardTabIconProps) {
  return <Icon name={materialIcon} size={size} />;
}
